/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import LOCAL_STORAGE_KEYS from "constants/STORAGE_KEYS";
import toast from "react-hot-toast";
import { fetchBase, FetchError, FetchSuccess } from "./managers";

export const getUser = async (eventId) => {
  try {
    const id = localStorage.getItem(LOCAL_STORAGE_KEYS.id);
    const res = await fetchBase(`user-dashboard/user/${id}`, null, {
      slugTarget: "url",
      eventId,
    });
    return new FetchSuccess(res);
  } catch (res) {
    throw new FetchError(res);
  }
};

export const unsubscribe = async (id, eventId) => {
  try {
    const res = await fetchBase(
      `user-dashboard/unsubscribe/${id}`,
      {
        method: "PATCH",
      },
      {
        slugTarget: "url",
        eventId,
      },
    );
    return new FetchSuccess(res);
  } catch (res) {
    throw new FetchError(res);
  }
};

export const getAttendees = async (eventId) => {
  try {
    const res = await fetchBase(`user-dashboard/attendees`, null, {
      slugTarget: "url",
      eventId,
    });
    return new FetchSuccess(res);
  } catch (res) {
    throw new FetchError(res);
  }
};

export const getFormCategories = async (eventId) => {
  try {
    const res = await fetchBase(
      `user-dashboard/registration-form-categories`,
      null,
      {
        slugTarget: "url",
        eventId,
      },
    );
    return new FetchSuccess(res);
  } catch (res) {
    throw new FetchError(res);
  }
};

export const getFormCategoryFields = async (id, eventId) => {
  try {
    const res = await fetchBase(
      `user-dashboard/registration-form-categories/${id}`,
      null,
      {
        slugTarget: "url",
        eventId,
      },
    );
    return new FetchSuccess(res);
  } catch (res) {
    throw new FetchError(res);
  }
};

export const getEventDefaultFlight = async (eventId) => {
  try {
    const res = await fetchBase(`user-dashboard/attendees`, null, {
      slugTarget: "url",
      eventId,
    });
    let data = await res.json();
    return data.flight_details;
  } catch (res) {
    throw new FetchError(res);
  }
};

export const updateUser = async (formData, opts, eventId) => {
  let settings = {
    hasContentType: false,
  };
  if (opts && typeof opts === "object") {
    settings = {
      ...settings,
      ...opts,
    };
  }
  try {
    const id = localStorage.getItem(LOCAL_STORAGE_KEYS.id);
    const body = settings.hasContentType ? JSON.stringify(formData) : formData;
    const res = await fetchBase(
      `user-dashboard/guest/${id}`,
      {
        method: "PATCH",
        body,
      },
      {
        slugTarget: "body",
        hasContentType: settings.hasContentType,
        eventId,
      },
    );
    return new FetchSuccess(res);
  } catch (res) {
    throw new FetchError(res);
  }
};

export const completeGuest = async (id, eventId) => {
  try {
    const res = await fetchBase(
      `user-dashboard/complete-guest-form/${id}`,
      {
        method: "PATCH",
      },
      {
        slugTarget: "url",
        eventId,
      },
    );
    return new FetchSuccess(res);
  } catch (res) {
    throw new FetchError(res);
  }
};

export const updateCompanion = async (id, formData, eventId) => {
  try {
    const res = await fetchBase(
      `user-dashboard/companion/${id}`,
      {
        method: "PATCH",
        body: formData,
      },
      {
        slugTarget: "body",
        hasContentType: false,
        eventId,
      },
    );
    return new FetchSuccess(res);
  } catch (res) {
    throw new FetchError(res);
  }
};

export const createCompanion = async (formData, eventId) => {
  try {
    const res = await fetchBase(
      `user-dashboard/companion`,
      {
        method: "POST",
        body: formData,
      },
      {
        slugTarget: "body",
        hasContentType: false,
        eventId,
      },
    );
    return new FetchSuccess(res);
  } catch (res) {
    throw new FetchError(res);
  }
};

export const checkPassport = async (url) => {
  try {
    const res = await fetchBase("user-dashboard/check-passport", {
      method: "POST",
      body: JSON.stringify({ url }),
    });
    if (res.status === 204) {
      toast(
        "We couldn't process your passport, but you can still complete the registration process",
      );
    }
    return new FetchSuccess(res);
  } catch (res) {
    throw new FetchError(res);
  }
};

export const getProfile = async (id, role, eventId) => {
  if (role !== "user" && role !== "companion") throw new Error("Invalid role");
  try {
    const res = await fetchBase(
      `user-dashboard/card-internal-data/${role}-data/${id}`,
      null,
      {
        slugTarget: "url",
        eventId,
      },
    );
    return new FetchSuccess(res);
  } catch (res) {
    throw new FetchError(res);
  }
};

export const logout = async (token) => {
  try {
    const res = await fetchBase(`user-dashboard/logout`, {
      method: "POST",
      ...(token ? { headers: { Authorization: `Bearer ${token}` } } : {}),
    });
    return new FetchSuccess(res);
  } catch (res) {
    // throw new FetchError(res);
    console.error(res);
  }
};
